import React from 'react'
import { withStyles } from 'material-ui/styles'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import Icon from '../assets/Icon'

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 'auto',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 2,
    '@media (max-width: 320px)': {
      display: 'none',
    },
  },
  flex: {
    flex: 1,
    fontWeight: 300,
    textTransform: 'capitalize',
  },
  menuButton: {
    marginLeft: -12,
  },
  avatar: {
    marginLeft: 3,
    cursor: 'pointer',
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    color: theme.palette.grey.contrastText,
    minHeight: 40,
    '&:hover': {
      backgroundColor: theme.palette.grey.main,
    },
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
})

const TopBar = props => {
  const { classes, name } = props
  return (
    <AppBar className={classes.root}>
      <Toolbar>
        <IconButton className={classes.menuButton} color="inherit" aria-label="Icon">
          <Icon />
        </IconButton>
        <Typography variant="title" color="inherit" className={classes.flex}>
          {name}
        </Typography>
      </Toolbar>
    </AppBar>
  )
}

export default withStyles(styles, {withTheme: true})(TopBar)


// WEBPACK FOOTER //
// ./src/components/TopBar.js